import { useMutation } from '@tanstack/react-query';

import { DataExplorerApi } from '../api/dataExplorer.api';

export const useDownloadDexpJob = () => {
  return useMutation(DataExplorerApi.downloadDexpJob);
};
